import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class ProctoringConfigValidationUtils {

	static configurationNameValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {

			const value = control.value;

			if (!value) {
				return null; // let Validators.required handle this
			}

			// Cannot contain only spaces
			if (value.trim().length === 0) {
				return { whitespace: true };
			}

			// Leading or trailing spaces
			if (value !== value.trim()) {
				return { trimSpaces: true };
			}

			// Minimum length
			if (value.trim().length < 3) {
				return { minLength: true };
			}

			// Maximum length
			if (value.trim().length > 100) {
				return { maxLength: true };
			}

			// HTML / XSS
			if (/<[^>]*>/.test(value)) {
				return { html: true };
			}

			// First character cannot be special
			if (!/^[A-Za-z0-9]/.test(value.trim())) {
				return { firstCharacter: true };
			}

			// Allowed characters
			if (!/^[A-Za-z0-9][A-Za-z0-9 _().-]*$/.test(value.trim())) {
				return { invalidCharacters: true };
			}

			return null;
		};
	}

	static proctoringDescriptionValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {

			const value = control.value;

			if (!value) {
				return null; // Optional field
			}

			// Cannot contain only spaces
			if (value.trim().length === 0) {
				return { whitespace: true };
			}

			// Leading or trailing spaces
			if (value !== value.trim()) {
				return { trimSpaces: true };
			}

			// Maximum 500 characters
			if (value.trim().length > 500) {
				return { maxLength: true };
			}

			// HTML / JavaScript
			if (/<[^>]*>/.test(value)) {
				return { html: true };
			}

			// Allow letters, numbers and common punctuation
			const pattern = /^[A-Za-z0-9\s.,!?'"():;@#%&*_/\\\-()[\]{}]+$/;

			if (!pattern.test(value.trim())) {
				return { invalidCharacters: true };
			}
			return null;
		};
	}


	static proctoringThresholdValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {

			const value = control.value;

			// Allow empty if not required
			if (value === null || value === '' || value === undefined) {
				return null;
			}

			// Numbers only
			if (!/^\d+$/.test(value.toString())) {
				return { numbersOnly: true };
			}

			const number = Number(value);

			// Less than 0
			if (number < 0) {
				return { min: true };
			}

			// Greater than 100
			if (number > 100) {
				return { max: true };
			}

			if (number === 0) {
	            return { zero: true };
            }
			return null;
		};
	}

}